import React from "react";
import Edit from "../../../assets/icon/NewsIcons/MainAdmin/NewsEdit";
import Delete from "../../../assets/icon/NewsIcons/MainAdmin/NewsDelete";
import Detail from "../../../assets/icon/NewsIcons/MainAdmin/NewsDetail";
import { ReactComponent as Right } from "../../../assets/icon/right.svg";
import { ReactComponent as Left } from "../../../assets/icon/left.svg";

const uniqueNames = (items, key) => [...new Set((items || []).map((item) => item?.[key]).filter(Boolean))];

const ValueList = ({ values, empty = "ثبت نشده" }) => values.length
    ? <div className="teacher-table-values">{values.map((value) => <span key={value}>{value}</span>)}</div>
    : <span className="teacher-table-empty">{empty}</span>;

const MainAdminTeacherTables = ({ detail, edit, deleted, writersList, setShowEditModal,
    setShowDeleteModal, setData, count, page, setPage, row, setRow, onViewTeacher }) => {
    const emailStatusLabel = { Missing: "نیازمند ایمیل", VerifiedOfficial: "رسمی تأییدشده", OfficialUnverified: "دانشگاهی تأییدنشده", PersonalDomain: "دامنه عمومی", Invalid: "نامعتبر", Bounced: "برگشتی" };
    const start = count > 0 ? ((page - 1) * Number(row)) + 1 : 0;
    const end = Math.min(page * Number(row), count || 0);

    return (
        <div className="teacher-table-shell rounded-[15px] pt-[15px] px-[15px] pb-[30px] overflow-auto border-borderGray border-2 w-full">
            <table className="teacher-admin-table w-full">
                <thead>
                    <tr className="h-[60px] w-full bg-lightBlue2">
                        <th className="rounded-r-[15px]">ردیف</th>
                        <th>استاد</th>
                        <th>دانشگاه</th>
                        <th>دانشکده</th>
                        <th>رشته</th>
                        <th>حوزه‌های پژوهشی</th>
                        <th>ایمیل و وضعیت</th>
                        <th className="rounded-l-[15px] text-center">عملیات</th>
                    </tr>
                </thead>
                <tbody>
                    {(writersList || []).map((item, index) => {
                        const assignments = item?.academicAssignments || [];
                        const universities = uniqueNames(assignments, "universityName");
                        if (!universities.length && item?.institutionName) universities.push(item.institutionName);
                        const colleges = uniqueNames(assignments, "collegeName");
                        const fields = uniqueNames(assignments, "fieldName");
                        const structuredAreas = uniqueNames(item?.structuredResearchAreas || [], "name");
                        const legacyAreas = !structuredAreas.length && item?.researchAreas
                            ? item.researchAreas.split(/[,;،]/).map((value) => value.trim()).filter(Boolean)
                            : [];
                        return (
                            <tr key={item.teacherId} className="border-b-2 border-borderGray">
                                <td>{index + 1 + ((page - 1) * Number(row))}</td>
                                <td><strong>{item?.name} {item?.family}</strong>{item?.academicTitle && <small>{item.academicTitle}</small>}{item?.department && <small>{item.department}</small>}</td>
                                <td><ValueList values={universities} /></td>
                                <td><ValueList values={colleges} /></td>
                                <td><ValueList values={fields} /></td>
                                <td><ValueList values={structuredAreas.length ? structuredAreas : legacyAreas} /></td>
                                <td className="teacher-table-email"><span dir="ltr">{item?.email || "بدون ایمیل"}</span>{item?.emailVerificationStatus === "VerifiedOfficial" && item?.officialPageUrl && <a href={item.officialPageUrl} target="_blank" rel="noreferrer">منبع تأیید</a>}{!item?.email && item?.suggestedEmail && <small dir="ltr">پیشنهاد: {item.suggestedEmail}</small>}<div className="teacher-table-badges"><small className={item?.dataQualityScore >= 70 ? "quality-good" : "quality-low"}>کیفیت {item?.dataQualityScore || 0}٪</small><small>{emailStatusLabel[item?.emailVerificationStatus] || "ثبت‌نشده"}</small><small>{item?.worksCount || 0} مقاله</small><small>{item?.citedByCount || 0} ارجاع</small>{item?.isActive === false && <small className="inactive">غیرفعال</small>}</div></td>
                                <td><div className="teacher-table-actions">
                                    {detail && <button title="مشاهده پروفایل کامل" onClick={() => onViewTeacher?.(item)}><Detail /></button>}
                                    {edit && <button title="ویرایش" onClick={() => { setShowEditModal(true); setData(item); }}><Edit /></button>}
                                    {deleted && <button title="حذف" onClick={() => { setShowDeleteModal(true); setData(item); }}><Delete /></button>}
                                </div></td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {!writersList?.length && <div className="teacher-table-no-result">استادی با فیلترهای انتخاب‌شده پیدا نشد.</div>}
            <div className="teacher-table-pagination">
                <label>تعداد ردیف در هر صفحه<select value={row} onChange={(event) => { setRow(Number(event.target.value)); setPage(1); }}><option value={5}>۵</option><option value={10}>۱۰</option><option value={25}>۲۵</option></select></label>
                <div><span>{start}-{end} از {count || 0}</span><button onClick={() => setPage(page + 1)} disabled={(count || 0) <= Number(row) * page}><Right /></button><button onClick={() => setPage(page - 1)} disabled={page <= 1}><Left /></button></div>
            </div>
        </div>
    );
};

export default MainAdminTeacherTables;
